import { defineAppConfig } from '@zto/zpage'
import type { App, AppWidgetsConfig } from '@zto/zpage'

export default defineAppConfig<AppWidgetsConfig>((app: App) => ({
  crud: {
    export: {
      api: 'base.addExportTask',
      searchParamProp: 'parameter'
    },
    table: {
      // columnFilter: true
    }
  }
}))
